enum FilterBarConstants {
  TOGGLE_SEARCH_BAR = '@FilterBar/TOGGLE_SEARCH_BAR',
  SET_SELECTED_FILTER = '@FilterBar/SET_SELECTED_FILTER',
  TOGGLE_FILTERS_BAR = '@FilterBar/TOGGLE_FILTERS_BAR',
}

export default FilterBarConstants;
